/* eslint-disable */
import styled from 'styled-components';
import { FaUserCircle, FaArrowRight } from "react-icons/fa";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  border: solid 1px #e0e0e0;
  border-radius: 4px;
  margin: 0 0 16px 0;
  padding: 12px;
  align-items: center;
  justify-content: space-between;
`;

export const Image: any = styled.img`
  height: 32px;
  width: 32px;
  border-radius: 16px;
`;

export const UserIcon = styled(FaUserCircle)`
  height: 32px;
  width: 32px;
  color: #b0b0b0;
  border-radius: 16px;
`;

export const ArrowRightIcon = styled(FaArrowRight).attrs({
  size: 14,
})`
  color: #333333;
`;

export const Text = styled.p`
  font-size: 14px;
  font-family: 'Graphik-Regular';
  color: #333;
  margin-left: 16px;
  line-height: 18px;
`;

export const LightText = styled.p`
  font-size: 12px;
  font-family: 'Graphik-Regular';
  color: #696969;
  margin-left: 16px;
  line-height: 14px;
`;

export const RowAlign = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
`;
export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StatusIndicator: any = styled.div`
display: flex;
  padding: 4px 8px 4px 8px;
  min-width: 40px;
  align-items: center;
  justify-content: center;
  border-radius: 32px;
  background-color: ${(props: any) => props.color};
  margin-right: 32px;
`;

export const StatusText: any = styled.div`
  font-size: 11px;
  font-family: 'Graphik-Regular';
  color: ${(props: any) => props.color};
`;

export const SiglaBadge = styled.div`
  display: flex;
  padding: 4px 8px 4px 8px;
  min-width: 40px;
  align-items: center;
  justify-content: center;
  border-radius: 32px;
  background-color: #f0f0f0;
  margin: 0 32px 0 32px;
`;

export const SiglaText = styled.p`
  font-size: 11px;
  font-family: 'Graphik-Regular';
  color: #333333;
`;
